// extracted by mini-css-extract-plugin
export var icon = "_4m-3";
export var subtitle = "_4m-2";
export var title = "_4m-1";
export var value = "_4m-0";